import api from './api';

export const listarDisciplinas = async () => {
  const response = await api.get('/disciplinas');
  return response.data;
};

export const obterDisciplina = async (id) => {
  const response = await api.get(`/disciplinas/${id}`);
  return response.data;
};

export const criarDisciplina = async (disciplinaData) => {
  const response = await api.post('/disciplinas', disciplinaData);
  return response.data;
};

export const atualizarDisciplina = async (id, disciplinaData) => {
  const response = await api.put(`/disciplinas/${id}`, disciplinaData);
  return response.data;
};

export const excluirDisciplina = async (id) => {
  const response = await api.delete(`/disciplinas/${id}`);
  return response.data;
};

export const listarDisciplinasPorClasse = async (classeId) => {
  const response = await api.get(`/disciplinas/classe/${classeId}`);
  return response.data;
};